import store from "src/page/store";
import { roleMapping, permissionMapping, EMPTY_STRING } from "src/components/constant/constant";

export type roleRequest = {
  organisation_id: string;
  value: string;
}[];

export const getRoleForOrganisation = (roles: roleRequest | null | undefined, orgId: string | undefined) => {
  if (orgId && Array.isArray(roles) && roles.length > 0) {
    const userRole = roles.find((role) => role?.organisation_id === orgId);

    return userRole ? roleMapping[userRole.value] : null;
  }
  return null;
};

export const checkPermission = (permisssion: string) => {
  const { auth } = store.getState();

  return Boolean(auth.cognitoConfig?.allowedPermissions?.includes(permisssion));
};

export const transformPermissionsBasedOnSubscription = (
  permissions: string[],
  subscriptionAttributes?: { price_breakup?: unknown[] },
  activeEntitlement?: { organisation_id: string; status: string } | null
): string[] => {
  const hasPricing = subscriptionAttributes?.price_breakup && subscriptionAttributes.price_breakup.length > 0;
  const hasActiveEntitlement = !!activeEntitlement && activeEntitlement.status === "ACTIVE";

  const shouldTransform = !hasPricing || !hasActiveEntitlement;

  if (!shouldTransform) {
    return permissions;
  }

  return permissions.map((permission) => {
    return permission || permissionMapping[permission];
  });
};

export const getCurrentRole = (roles: { organisation_id: string; value: string }[] | null) => {
  if (roles === null) return { value: EMPTY_STRING };
  const { auth } = store.getState();

  return roles?.find((role) => role.organisation_id === auth.cognitoConfig.currentOrganisation?.organisation_id);
};
